export let PartnerType;
(function (PartnerType) {
  PartnerType["DirectoryUser"] = "DIRECTORY_USER";
})(PartnerType || (PartnerType = {}));